import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import { ContentProvider } from './content/ContentContext';
import PublicLayout from './components/layout/PublicLayout';
import Home from './pages/Home';
import Storia from './pages/Storia';
import TourPage from './pages/Tour';
import Gare from './pages/Gare';
import Iscrizioni from './pages/Iscrizioni';
import Contatti from './pages/Contatti';
import Privacy from './pages/Privacy';
import Termini from './pages/Termini';
import BookingOutcome from './pages/BookingOutcome';
import AdminLogin from './admin/AdminLogin';
import AdminRoute from './admin/AdminRoute';
import AdminLayout from './admin/AdminLayout';
import ContentAdmin from './admin/pages/ContentAdmin';
import GalleryAdmin from './admin/pages/GalleryAdmin';
import ToursAdmin from './admin/pages/ToursAdmin';
import SlotsAdmin from './admin/pages/SlotsAdmin';
import MembershipsAdmin from './admin/pages/MembershipsAdmin';
import IntegrationsAdmin from './admin/pages/IntegrationsAdmin';
import ProposalsAdmin from './admin/pages/ProposalsAdmin';

const App: React.FC = () => (
  <LanguageProvider>
  <ContentProvider>
    <BrowserRouter>
      <Routes>
        {/* Sito pubblico */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/storia" element={<Storia />} />
          <Route path="/tour" element={<TourPage />} />
          <Route path="/gare" element={<Gare />} />
          <Route path="/rally-raid" element={<Navigate to="/gare" replace />} />
          <Route path="/iscrizioni" element={<Iscrizioni />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/termini" element={<Termini />} />
          <Route path="/prenotazione/conferma" element={<BookingOutcome mode="confirm" />} />
          <Route path="/prenotazione/annulla" element={<BookingOutcome mode="cancel" />} />
        </Route>

        {/* Dashboard admin */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
          <Route index element={<Navigate to="/admin/content" replace />} />
          <Route path="content" element={<ContentAdmin />} />
          <Route path="gallery" element={<GalleryAdmin />} />
          <Route path="tours" element={<ToursAdmin />} />
          <Route path="slots" element={<SlotsAdmin />} />
          <Route path="memberships" element={<MembershipsAdmin />} />
          <Route path="proposals" element={<ProposalsAdmin />} />
          <Route path="integrations" element={<IntegrationsAdmin />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </ContentProvider>
  </LanguageProvider>
);

export default App;
